import { render, staticRenderFns } from "./NewStudent.vue?vue&type=template&id=63438366&scoped=true&"
import script from "./NewStudent.vue?vue&type=script&lang=js&"
export * from "./NewStudent.vue?vue&type=script&lang=js&"
import style0 from "./NewStudent.vue?vue&type=style&index=0&id=63438366&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63438366",
  null
  
)

component.options.__file = "NewStudent.vue"
export default component.exports